import styled from 'styled-components';
import device from '../mediaQueries';

const VerticalSpacer = styled.div.attrs(({ className }) => ({
  className,
}))<{
  backgroundColor?: string;
  className?: string;
  desktopHeight?: string;
  height?: string;
  mobileHeight?: string;
}>`
  ${({ backgroundColor }) => (backgroundColor ? `background-color: ${backgroundColor};` : null)};

  ${device.mobile`
    ${({ mobileHeight, height }) => (mobileHeight || height) && `height: ${mobileHeight || height}`};
  `}
  ${device.desktop`
    ${({ desktopHeight, height }) => (desktopHeight || height) && `height: ${desktopHeight || height}`};
  `}
`;

export default VerticalSpacer;
